var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.masterAdmin === true && !_vm.$store.state.switch_admin_username
            ? _c("masteradmin-sidebar-menu")
            : _vm._e(),
          _vm._v(" "),
          _vm.admin === true ? _c("admin-sidebar-menu") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper" }, [
            _c("div", { staticClass: "container-wrapper center" }, [
              _c(
                "div",
                [
                  _vm.showBackButton ? _c("GoBack") : _vm._e(),
                  _vm._v(" "),
                  _c("h3", { staticClass: "d-inline heading" }, [
                    _vm._v(_vm._s(_vm.pageName))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "heading-seperator" }),
              _vm._v(" "),
              _vm.action == "view-profile"
                ? _c("div", { staticClass: "content-main-wrapper center" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass: "loading_show"
                      },
                      [_c("div", { staticClass: "spinner-border text-danger" })]
                    ),
                    _vm._v(" "),
                    _vm.loading === false
                      ? _c(
                          "div",
                          [
                            _c("flash-message", {
                              attrs: { autoHide: "", variant: "success" }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "row marginbot10 profile-heading"
                              },
                              [
                                _vm._m(0),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-md-3 col-sm-3 col-xs-3",
                                    attrs: { id: "profile-link-wrapper" }
                                  },
                                  [
                                    _c("span", { staticClass: "float-right" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "profile-link",
                                          on: {
                                            click: function($event) {
                                              return _vm.setprofile_mode(
                                                "edit-profile"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("EDIT")]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "row marginbot10" }, [
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-8 col-sm-8 col-xs-8" },
                                [_vm._v(_vm._s(_vm.first_name))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row marginbot10" }, [
                              _vm._m(2),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-8 col-sm-8 col-xs-8" },
                                [_vm._v(_vm._s(_vm.last_name))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row marginbot10" }, [
                              _vm._m(3),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-8 col-sm-8 col-xs-8" },
                                [_vm._v(_vm._s(_vm.email))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row marginbot10" }, [
                              _vm._m(4),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-8 col-sm-8 col-xs-8" },
                                _vm._l(_vm.roles, function(option, key, index) {
                                  return _c("span", { staticClass: "roles" }, [
                                    _vm.roles.length == key + 1
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.rolesFormatter(option))
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.rolesFormatter(option)) +
                                              ", "
                                          )
                                        ])
                                  ])
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row marginbot10" }, [
                              _vm.isMenteeUserProfile()
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "col-md-4 col-sm-4 col-xs-4"
                                    },
                                    [_c("label", [_vm._v("Mentors")])]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "col-md-4 col-sm-4 col-xs-4"
                                    },
                                    [_c("label", [_vm._v("Groups")])]
                                  ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-8 col-sm-8 col-xs-8" },
                                [_vm._v(_vm._s(_vm.group_names.join(", ")))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row marginbot10" }, [
                              _vm._m(5),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-8 col-sm-8 col-xs-8" },
                                [_vm._v(_vm._s(_vm.phone_number))]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isUser(),
                                    expression: "isUser()"
                                  }
                                ]
                              },
                              [
                                _c("div", { staticClass: "profile-sec-sep" }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row marginbot10 profile-heading",
                                    attrs: { id: "profile-link-wrapper" }
                                  },
                                  [
                                    _vm._m(6),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 col-sm-3 col-xs-3"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "float-right" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "profile-link",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setprofile_mode(
                                                      "change-password"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("EDIT")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._m(7)
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isUser(),
                                    expression: "isUser()"
                                  }
                                ]
                              },
                              [
                                _c("div", { staticClass: "profile-sec-sep" }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row marginbot10 profile-heading",
                                    attrs: { id: "profile-link-wrapper" }
                                  },
                                  [
                                    _vm._m(8),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 col-sm-3 col-xs-3"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "float-right" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "profile-link",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setprofile_mode(
                                                      "change-password"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("EDIT")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._m(9)
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isMenteeNotificationSettings(),
                                    expression: "isMenteeNotificationSettings()"
                                  }
                                ]
                              },
                              [
                                _c("div", { staticClass: "profile-sec-sep" }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row marginbot10 profile-heading",
                                    attrs: { id: "profile-link-wrapper" }
                                  },
                                  [
                                    _vm._m(10),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 col-sm-3 col-xs-3"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "float-right" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "profile-link",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setprofile_mode(
                                                      "notification-settings"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("EDIT")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "row marginbot10" }, [
                                  _vm._m(11),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-md-8 col-sm-8 col-xs-8",
                                      staticStyle: {
                                        "text-transform": "capitalize"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.email_display_flag))]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row marginbot10" }, [
                                  _vm._m(12),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-md-8 col-sm-8 col-xs-8",
                                      staticStyle: {
                                        "text-transform": "capitalize"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.sms_display_flag))]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row marginbot10" }, [
                                  _vm._m(13),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-md-8 col-sm-8 col-xs-8",
                                      staticStyle: {
                                        "text-transform": "capitalize"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.frequency_value.toLowerCase()
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isMenteeProfile(),
                                    expression: "isMenteeProfile()"
                                  }
                                ]
                              },
                              [
                                _c("div", { staticClass: "profile-sec-sep" }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row marginbot10 profile-heading",
                                    attrs: { id: "profile-link-wrapper" }
                                  },
                                  [
                                    _vm._m(14),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 col-sm-3 col-xs-3"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "float-right" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.isMenteeTasklistEdit(),
                                                    expression:
                                                      "isMenteeTasklistEdit()"
                                                  }
                                                ],
                                                staticClass: "profile-link",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setprofile_mode(
                                                      "tasklist-assignment"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("EDIT")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "row marginbot10" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12" },
                                    _vm._l(_vm.taskListsNames, function(
                                      taskListsName
                                    ) {
                                      return _c("ul", [
                                        _c("li", [
                                          _vm._v(_vm._s(taskListsName))
                                        ])
                                      ])
                                    }),
                                    0
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm.action == "edit-profile"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "content-main-wrapper center edit-profile-wrapper",
                      attrs: { id: "edit-profile-wrapper" }
                    },
                    [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.onUpdate($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "row margin-bottom-15" }, [
                            _c("div", { staticClass: "col-12 col-sm-12" }, [
                              _vm._m(15),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.first_name,
                                    expression: "first_name"
                                  }
                                ],
                                ref: "first_name",
                                staticClass: "col-12 col-sm-12 input-height-35",
                                attrs: {
                                  type: "first_name",
                                  name: "first_name",
                                  "data-vv-as": "First name",
                                  maxlength: "180"
                                },
                                domProps: { value: _vm.first_name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.first_name = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.verrors.has("first_name"),
                                      expression: "verrors.has('first_name')"
                                    }
                                  ],
                                  staticClass: "validate-warning-msg"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.verrors.first("first_name"))
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row margin-bottom-15" }, [
                            _c("div", { staticClass: "col-12 col-sm-12" }, [
                              _vm._m(16),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.last_name,
                                    expression: "last_name"
                                  }
                                ],
                                ref: "last_name",
                                staticClass: "col-12 col-sm-12 input-height-35",
                                attrs: {
                                  type: "last_name",
                                  name: "last_name",
                                  "data-vv-as": "Last name",
                                  maxlength: "180"
                                },
                                domProps: { value: _vm.last_name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.last_name = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.verrors.has("last_name"),
                                      expression: "verrors.has('last_name')"
                                    }
                                  ],
                                  staticClass: "validate-warning-msg"
                                },
                                [_vm._v(_vm._s(_vm.verrors.first("last_name")))]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.admin_flag === true && _vm.role_options != ""
                            ? _c(
                                "div",
                                { staticClass: "row margin-bottom-15" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-sm-12" },
                                    [
                                      _vm._m(17),
                                      _vm._v(" "),
                                      _vm._l(_vm.role_options, function(
                                        option,
                                        key,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-sm-12 chkboxwrapper"
                                          },
                                          [
                                            index == 0
                                              ? _c("div", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.roles,
                                                        expression: "roles"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate"
                                                      }
                                                    ],
                                                    attrs: {
                                                      type: "checkbox",
                                                      name: "roles",
                                                      "data-vv-rules":
                                                        "required",
                                                      "data-vv-as": "Roles",
                                                      disabled:
                                                        _vm.is_mentee == 1 &&
                                                        (key == "ROLE_MENTOR" ||
                                                          key ==
                                                            "ROLE_INSTRUCTOR")
                                                    },
                                                    domProps: {
                                                      value: key,
                                                      checked: Array.isArray(
                                                        _vm.roles
                                                      )
                                                        ? _vm._i(
                                                            _vm.roles,
                                                            key
                                                          ) > -1
                                                        : _vm.roles
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a = _vm.roles,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = key,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.roles = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.roles = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.roles = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    { attrs: { for: option } },
                                                    [_vm._v(_vm._s(option))]
                                                  )
                                                ])
                                              : _c("div", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.roles,
                                                        expression: "roles"
                                                      }
                                                    ],
                                                    attrs: {
                                                      type: "checkbox",
                                                      name: "roles",
                                                      disabled:
                                                        _vm.is_mentee == 1 &&
                                                        (key == "ROLE_MENTOR" ||
                                                          key ==
                                                            "ROLE_INSTRUCTOR")
                                                    },
                                                    domProps: {
                                                      value: key,
                                                      checked: Array.isArray(
                                                        _vm.roles
                                                      )
                                                        ? _vm._i(
                                                            _vm.roles,
                                                            key
                                                          ) > -1
                                                        : _vm.roles
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a = _vm.roles,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = key,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.roles = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.roles = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.roles = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    { attrs: { for: option } },
                                                    [_vm._v(_vm._s(option))]
                                                  )
                                                ])
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.verrors.has("roles"),
                                              expression: "verrors.has('roles')"
                                            }
                                          ],
                                          staticClass: "validate-warning-msg"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.verrors.first("roles"))
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showGroupEdit,
                                  expression: "showGroupEdit"
                                }
                              ],
                              staticClass: "row margin-bottom-15"
                            },
                            [
                              _vm.isMenteeUserProfile()
                                ? _c(
                                    "div",
                                    { staticClass: "col-12 col-sm-12" },
                                    [
                                      _vm._m(18),
                                      _vm._v(" "),
                                      _vm._l(_vm.groups_options, function(
                                        option,
                                        key,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-sm-12 chkboxwrapper"
                                          },
                                          [
                                            key == 0
                                              ? _c("div", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.groups,
                                                        expression: "groups"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate"
                                                      }
                                                    ],
                                                    attrs: {
                                                      id: option.id,
                                                      type: "checkbox",
                                                      name: "mentors",
                                                      "data-vv-rules":
                                                        "required"
                                                    },
                                                    domProps: {
                                                      value: option.id,
                                                      checked: Array.isArray(
                                                        _vm.groups
                                                      )
                                                        ? _vm._i(
                                                            _vm.groups,
                                                            option.id
                                                          ) > -1
                                                        : _vm.groups
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a = _vm.groups,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = option.id,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.groups = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.groups = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.groups = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: option.groupName
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(option.groupName)
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _c("div", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.groups,
                                                        expression: "groups"
                                                      }
                                                    ],
                                                    attrs: {
                                                      id: option.id,
                                                      type: "checkbox",
                                                      name: "mentors"
                                                    },
                                                    domProps: {
                                                      value: option.id,
                                                      checked: Array.isArray(
                                                        _vm.groups
                                                      )
                                                        ? _vm._i(
                                                            _vm.groups,
                                                            option.id
                                                          ) > -1
                                                        : _vm.groups
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a = _vm.groups,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = option.id,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.groups = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.groups = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.groups = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: option.groupName
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(option.groupName)
                                                      )
                                                    ]
                                                  )
                                                ])
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.verrors.has("mentors"),
                                              expression:
                                                "verrors.has('mentors')"
                                            }
                                          ],
                                          staticClass: "validate-warning-msg"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.verrors.first("mentors"))
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "col-12 col-sm-12" },
                                    [
                                      _vm._m(19),
                                      _vm._v(" "),
                                      _vm._l(_vm.groups_options, function(
                                        option,
                                        key,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-sm-12 chkboxwrapper"
                                          },
                                          [
                                            key == 0
                                              ? _c("div", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.groups,
                                                        expression: "groups"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate"
                                                      }
                                                    ],
                                                    attrs: {
                                                      id: option.id,
                                                      type: "checkbox",
                                                      name: "groups",
                                                      "data-vv-rules":
                                                        "required"
                                                    },
                                                    domProps: {
                                                      value: option.id,
                                                      checked: Array.isArray(
                                                        _vm.groups
                                                      )
                                                        ? _vm._i(
                                                            _vm.groups,
                                                            option.id
                                                          ) > -1
                                                        : _vm.groups
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a = _vm.groups,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = option.id,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.groups = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.groups = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.groups = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: option.groupName
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(option.groupName)
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _c("div", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.groups,
                                                        expression: "groups"
                                                      }
                                                    ],
                                                    attrs: {
                                                      id: option.id,
                                                      type: "checkbox",
                                                      name: "groups"
                                                    },
                                                    domProps: {
                                                      value: option.id,
                                                      checked: Array.isArray(
                                                        _vm.groups
                                                      )
                                                        ? _vm._i(
                                                            _vm.groups,
                                                            option.id
                                                          ) > -1
                                                        : _vm.groups
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a = _vm.groups,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = option.id,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.groups = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.groups = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.groups = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: option.groupName
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(option.groupName)
                                                      )
                                                    ]
                                                  )
                                                ])
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.verrors.has("groups"),
                                              expression:
                                                "verrors.has('groups')"
                                            }
                                          ],
                                          staticClass: "validate-warning-msg"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.verrors.first("groups"))
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "row margin-bottom-15" }, [
                            _c("div", { staticClass: "col-12 col-sm-12" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "col-12",
                                  attrs: { for: "phone_number" }
                                },
                                [_vm._v("Phone Number : ")]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.phone_number,
                                    expression: "phone_number"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        regex: _vm.phoneNumberValidRegex()
                                      }
                                    },
                                    expression:
                                      "{ rules: { regex: phoneNumberValidRegex() } }"
                                  }
                                ],
                                ref: "phone_number",
                                staticClass: "col-12 col-sm-12 input-height-35",
                                attrs: {
                                  type: "phone_number",
                                  name: "phone_number",
                                  "data-vv-as": "Phone number",
                                  maxlength: "20"
                                },
                                domProps: { value: _vm.phone_number },
                                on: {
                                  keyup: function($event) {
                                    return _vm.phoneNumberFormat()
                                  },
                                  blur: function($event) {
                                    return _vm.phoneNumberFormat()
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.phone_number = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.verrors.has("phone_number"),
                                      expression: "verrors.has('phone_number')"
                                    }
                                  ],
                                  staticClass: "validate-warning-msg"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.verrors.first("phone_number"))
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._m(20),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } })
                        ]
                      )
                    ]
                  )
                : _vm.action == "notification-settings"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "content-main-wrapper notification-wrapper center edit-profile-wrapper",
                      attrs: { id: "edit-profile-wrapper" }
                    },
                    [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.updateMenteesNotifications($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "row margin-bottom-15" }, [
                            _c("div", { staticClass: "col-12 col-sm-12" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "col-12",
                                  staticStyle: {
                                    "font-size": "16px",
                                    "padding-bottom": "20px"
                                  },
                                  attrs: { for: "roles" }
                                },
                                [_vm._v("Notification Settings : ")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-sm-12 override-padding "
                                  },
                                  [
                                    _vm._m(21),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-9 float-left override-padding"
                                      },
                                      [
                                        _c("label", { staticClass: "switch" }, [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.email_flag,
                                                expression: "email_flag"
                                              }
                                            ],
                                            staticClass: "custom-control-input",
                                            attrs: {
                                              value: "1",
                                              id: "email_flag",
                                              type: "checkbox",
                                              name: "email_flag"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.email_flag
                                              )
                                                ? _vm._i(_vm.email_flag, "1") >
                                                  -1
                                                : _vm.email_flag
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a = _vm.email_flag,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = "1",
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.email_flag = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.email_flag = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.email_flag = $$c
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "slider round"
                                          })
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticStyle: { clear: "both" } }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-sm-12 override-padding"
                                  },
                                  [
                                    _vm._m(22),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "float-left col-9 override-padding "
                                      },
                                      [
                                        _c("label", { staticClass: "switch" }, [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.sms_flag,
                                                expression: "sms_flag"
                                              }
                                            ],
                                            staticClass: "custom-control-input",
                                            attrs: {
                                              value: "1",
                                              type: "checkbox",
                                              id: "sms_flag",
                                              name: "sms_flag"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.sms_flag
                                              )
                                                ? _vm._i(_vm.sms_flag, "1") > -1
                                                : _vm.sms_flag
                                            },
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$a = _vm.sms_flag,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = "1",
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.sms_flag = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.sms_flag = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.sms_flag = $$c
                                                  }
                                                },
                                                function($event) {
                                                  return _vm.displayNotificationSetting()
                                                }
                                              ]
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "slider round"
                                          })
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticStyle: { clear: "both" } })
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.verrors.has("roles"),
                                      expression: "verrors.has('roles')"
                                    }
                                  ],
                                  staticClass: "validate-warning-msg"
                                },
                                [_vm._v(_vm._s(_vm.verrors.first("roles")))]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.notification_phone
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row col-12 margin-bottom-15 override-padding"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-12" },
                                      [
                                        _vm._m(23),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required|numeric",
                                              expression: "'required|numeric'"
                                            },
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.phone_number,
                                              expression: "phone_number"
                                            }
                                          ],
                                          ref: "phone_number",
                                          staticClass:
                                            "col-12 col-sm-12 input-height-35",
                                          attrs: {
                                            type: "phone_number",
                                            name: "phone_number",
                                            "data-vv-as": "Phone number",
                                            maxlength: "20"
                                          },
                                          domProps: { value: _vm.phone_number },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.phone_number =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.verrors.has(
                                                  "phone_number"
                                                ),
                                                expression:
                                                  "verrors.has('phone_number')"
                                              }
                                            ],
                                            staticClass: "validate-warning-msg"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.verrors.first(
                                                  "phone_number"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 col-sm-12" }, [
                              _vm._m(24),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-9 col-12 float-left override-padding create_tasks_status"
                                },
                                _vm._l(_vm.frequency_options, function(
                                  option,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-5 float-left col-12 override-padding"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.frequency_value,
                                            expression: "frequency_value"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "frequency_value"
                                        },
                                        domProps: {
                                          value: option.value,
                                          checked: _vm._q(
                                            _vm.frequency_value,
                                            option.value
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.frequency_value = option.value
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", [_vm._v(_vm._s(option.text))])
                                    ]
                                  )
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticStyle: { clear: "both" } })
                          ]),
                          _vm._v(" "),
                          _vm._m(25)
                        ]
                      )
                    ]
                  )
                : _vm.action == "tasklist-assignment"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "content-main-wrapper center edit-profile-wrapper",
                      attrs: { id: "edit-profile-wrapper" }
                    },
                    [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.updateMenteesTasklist($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "row margin-bottom-15" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 col-sm-12" },
                              [
                                _vm._m(26),
                                _vm._v(" "),
                                _vm._l(_vm.editTaskLists, function(
                                  option,
                                  key,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-sm-12 tasklist-assign-wrapper"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "chkboxwrapper" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.taskListsAssigned,
                                                expression: "taskListsAssigned"
                                              }
                                            ],
                                            attrs: {
                                              id: option.id,
                                              type: "checkbox",
                                              name: "tasklist_assigned"
                                            },
                                            domProps: {
                                              value: option.id,
                                              checked: Array.isArray(
                                                _vm.taskListsAssigned
                                              )
                                                ? _vm._i(
                                                    _vm.taskListsAssigned,
                                                    option.id
                                                  ) > -1
                                                : _vm.taskListsAssigned
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a = _vm.taskListsAssigned,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = option.id,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.taskListsAssigned = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.taskListsAssigned = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.taskListsAssigned = $$c
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { attrs: { for: option.name } },
                                            [_vm._v(_vm._s(option.name))]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.verrors.has("roles"),
                                        expression: "verrors.has('roles')"
                                      }
                                    ],
                                    staticClass: "validate-warning-msg"
                                  },
                                  [_vm._v(_vm._s(_vm.verrors.first("roles")))]
                                )
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(27)
                        ]
                      )
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "content-main-wrapper center edit-profile-wrapper",
                      attrs: { id: "edit-profile-wrapper" }
                    },
                    [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.onSubmit($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "row margin-bottom-15" }, [
                            _c("div", { staticClass: "col-12 col-sm-12" }, [
                              _vm._m(28),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.password,
                                    expression: "password"
                                  }
                                ],
                                ref: "password",
                                staticClass: "col-12 col-sm-12 input-height-35",
                                attrs: {
                                  type: "password",
                                  name: "password",
                                  id: "password",
                                  "data-vv-as": "Password",
                                  maxlength: "20"
                                },
                                domProps: { value: _vm.password },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.password = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.verrors.has("password"),
                                      expression: "verrors.has('password')"
                                    }
                                  ],
                                  staticClass: "validate-warning-msg"
                                },
                                [_vm._v(_vm._s(_vm.verrors.first("password")))]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row margin-bottom-15" }, [
                            _c("div", { staticClass: "col-12 col-sm-12" }, [
                              _vm._m(29),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|confirmed:password",
                                    expression: "'required|confirmed:password'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.confirm_password,
                                    expression: "confirm_password"
                                  }
                                ],
                                ref: "confirm_password",
                                staticClass: "col-12 col-sm-12 input-height-35",
                                attrs: {
                                  type: "password",
                                  name: "confirm_password",
                                  id: "confirm_password",
                                  "data-vv-as": "Confirm password",
                                  maxlength: "20"
                                },
                                domProps: { value: _vm.confirm_password },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.confirm_password = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.verrors.has(
                                        "confirm_password"
                                      ),
                                      expression:
                                        "verrors.has('confirm_password')"
                                    }
                                  ],
                                  staticClass: "validate-warning-msg"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.verrors.first("confirm_password")
                                    )
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._m(30)
                        ]
                      )
                    ]
                  )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9 col-sm-9 col-xs-9" }, [
      _c("h3", [_vm._v("Personal Details")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 col-sm-4 col-xs-4" }, [
      _c("label", [_vm._v("First Name")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 col-sm-4 col-xs-4" }, [
      _c("label", [_vm._v("Last Name")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 col-sm-4 col-xs-4" }, [
      _c("label", [_vm._v("Email")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 col-sm-4 col-xs-4" }, [
      _c("label", [_vm._v("Role")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 col-sm-4 col-xs-4" }, [
      _c("label", [_vm._v("Phone Number")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9 col-sm-9 col-xs-9" }, [
      _c("h3", [_vm._v("Change Password")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row marginbot10" }, [
      _c("div", { staticClass: "col-md-4 col-sm-4 col-xs-4" }, [
        _c("label", [_vm._v("Password")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8 col-sm-8 col-xs-8" }, [
        _vm._v("********")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9 col-sm-9 col-xs-9" }, [
      _c("h3", [_vm._v("My Documents")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row marginbot10" }, [
      _c("div", { staticClass: "col-md-4 col-sm-4 col-xs-4" }, [
        _c("label", [_vm._v("Password")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8 col-sm-8 col-xs-8" }, [
        _vm._v("********")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9 col-sm-9 col-xs-9" }, [
      _c("h3", [_vm._v("Notification Settings")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 col-sm-4 col-xs-4" }, [
      _c("label", [_vm._v("Email")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 col-sm-4 col-xs-4" }, [
      _c("label", [_vm._v("SMS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 col-sm-4 col-xs-4" }, [
      _c("label", [_vm._v("Frequency")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9 col-sm-9 col-xs-9" }, [
      _c("h3", [_vm._v("Tasklist Assignment")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "col-12", attrs: { for: "first_name" } },
      [
        _vm._v("First name : "),
        _c("span", { staticClass: "required" }, [_vm._v("*")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-12", attrs: { for: "last_name" } }, [
      _vm._v("Last name : "),
      _c("span", { staticClass: "required" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-12", attrs: { for: "roles" } }, [
      _vm._v("Roles : "),
      _c("span", { staticClass: "required" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-12", attrs: { for: "roles" } }, [
      _vm._v("Mentors : "),
      _c("span", { staticClass: "required" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-12", attrs: { for: "roles" } }, [
      _vm._v("Groups : "),
      _c("span", { staticClass: "required" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "submit margin-bottom-15 float-right" }, [
      _c(
        "button",
        { staticClass: "btn btn-info btn-md", attrs: { type: "submit" } },
        [_vm._v("Update Profile")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 float-left override-padding" }, [
      _c("label", { staticClass: "label-bold", attrs: { for: "" } }, [
        _vm._v("Email")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "float-left col-3  override-padding" }, [
      _c("label", { staticClass: "label-bold", attrs: { for: "" } }, [
        _vm._v("SMS")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "col-12", attrs: { for: "phone_number" } },
      [
        _vm._v("Phone Number : "),
        _c("span", { staticClass: "required" }, [_vm._v("*")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 float-left override-padding" }, [
      _c("label", { staticClass: "label-bold", attrs: { for: "" } }, [
        _vm._v("Frequency")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "submit margin-bottom-15 float-right" }, [
      _c(
        "button",
        { staticClass: "btn btn-info btn-md", attrs: { type: "submit" } },
        [_vm._v("Update")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-12", attrs: { for: "roles" } }, [
      _vm._v("Tasklists to be assigned : "),
      _c("span", { staticClass: "required" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "submit margin-bottom-15 float-right" }, [
      _c(
        "button",
        { staticClass: "btn btn-info btn-md", attrs: { type: "submit" } },
        [_vm._v("Update")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-12", attrs: { for: "password" } }, [
      _vm._v("New Password : "),
      _c("span", { staticClass: "required" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "col-12", attrs: { for: "confirm_password" } },
      [
        _vm._v("Confirm Password : "),
        _c("span", { staticClass: "required" }, [_vm._v("*")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "submit margin-bottom-15 float-right" }, [
      _c(
        "button",
        { staticClass: "btn btn-info btn-md", attrs: { type: "submit" } },
        [_vm._v("Update Password")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3783cec5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3783cec5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user_profile.vue
// module id = null
// module chunks = 